import React from 'react';
import Icon from './Icon';
import Popup from './Popup';

export interface InfoPopupProps {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  footer?: React.ReactNode;
  content?: React.ReactNode;
  children?: React.ReactNode;
  onClose: (value: boolean) => void;
}

const WARNING_MODAL_DURATION = 8000;

const InfoPopup: React.FC<InfoPopupProps> = ({
  title,
  footer,
  content,
  onClose,
  children,
  icon = <Icon className="fb-icon--warning text-2xl kiosk:text-4xl text-default absolute"/>,
}) => (
  <Popup onClose={onClose} duration={WARNING_MODAL_DURATION} className="!bg-popup-bg">
    <div className="flex flex-col items-center m-auto kiosk:mb-52 max-w-4xl sm:max-w-none w-full sm:w-auto sm:mx-4 bg-popup-bg rounded-t-card sm:rounded-card kiosk:rounded-admin-card p-8 kiosk:p-20">
      <div className="rounded-full size-28 kiosk:size-52 bg-overlay relative flex justify-center items-center">
        {icon}
      </div>
      <span className="flex flex-col items-center gap-2.5 kiosk:gap-5 text-center mt-5 kiosk:mt-10">
        {title && <h1>{title}</h1>}
        {content ?? children}
      </span>
      {footer}
    </div>
  </Popup>
);

export default InfoPopup;
